module.exports = __webpack_public_path__ + "img/02.676961fc.jpg";